{
  "version": 1,
  "asset_id": "96492d69-94bf-431c-a0f7-3c2d8f043a3f",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/96492d69-94bf-431c-a0f7-3c2d8f043a3f/esenyurt-hizli-elektrikci-7-24-dukkan-2.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/96492d69-94bf-431c-a0f7-3c2d8f043a3f/esenyurt-hizli-elektrikci-7-24-dukkan-2.jpg",
  "original_filename": "esenyurt-hizli-elektrikci-7-24-dukkan-2.jpg",
  "size": 567726,
  "content_type": "image/jpeg",
  "created_at": "2026-09-12T10:56:04Z"
}
